import dieselFuelInjectionService from '../diesel-fuel-injection-service/config.js';

export default {
  ...dieselFuelInjectionService,
  includes: [...dieselFuelInjectionService.includes, 'diesel-fuel-injection-service'],
};
